import { readCookie } from '../Utility/Cookie'

export const LOGIN_CHANGE_EVENT = 'login:change'
export const LOGIN_COOKIE_NAME = 'vhw_login'

export interface LoginChangeDetail {
  isLoggedIn: boolean
}

// The authoritative login state is the httpOnly `vhw_session` cookie owned by the
// AuthController; the `vhw_login` cookie read here is only a JS-readable display flag that
// the server sets/clears alongside it. This is a UX signal, never a security boundary — the
// actual booking submission is protected by the session token against the middleware API.
class LoginStateService {
  public isLoggedIn(): boolean {
    return readCookie(LOGIN_COOKIE_NAME) === '1'
  }

  // The server owns both cookies (set on /api/auth/verify-otp, cleared on /api/auth/logout);
  // callers invoke this after a successful API response so the UI reacts immediately.
  public notifyChange(isLoggedIn: boolean): void {
    const event = new CustomEvent<LoginChangeDetail>(LOGIN_CHANGE_EVENT, {
      detail: { isLoggedIn }
    })
    document.dispatchEvent(event)
  }
}

export default new LoginStateService()
